// extracted by mini-css-extract-plugin
export default {"fitment-position":"product-set-image__fitment-position___1DODa"};